import config from "appConfig";
import { Slide } from "@jelly/lesson";
import a from "./components/a";
import b from "./components/b";
import c from "./components/c";
import d from "./components/d";
import e from "./components/e";

const principle: Slide = {
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      colSpan: {
        "0:0": 2,
      },
      colsSize: [1, 3],
      rowsSize: [1, 9],
      gap: "20px",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Room acoustics measurement and simulation of an existing space\n",
                  styles: {
                    fontSize: "16px",
                    fontWeight: "700",
                  },
                  scrollbars: false,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    `On the right hand side, the room impulse response and the evaluated room acoustic parameters, reverberation time and clarity, are presented for four different sound source - receiver combinations and as the average result.` +
                    `<br />` +
                    `<br />` +
                    `The room impulse responses look similar, the most striking difference is the level of the direct sound, which decreases if the distance of the sound source and the receiver increases. The decay of the reflections is similar, which also shows in the evaluated reverberation time, which has a typical value for a chamber music venue of around 1.3 s on average.` +
                    `<br />` +
                    `<br />` +
                    `The clarity parameter, however, is more position depend and therefore shows more variation between the four evaluated positions.` +
                    `<br />` +
                    `<br />` +
                    `<img alt="img" data- src="${config.ASSETS_URL}/03/case-01/principle/3-description.png" />`,
                  styles: {
                    fontSize: "12px",
                    fontWeight: "600",
                  },
                  scrollbars: true,
                },
              },
            },
          },
          {
            variant: "layout",
            data: {
              type: "controlsToggleExtraContent",
              options: {
                controls: [
                  {
                    type: "dropdown",
                    options: {
                      label: "Choose a room impulse response",
                      labelPosition: "left",
                    },
                    items: [
                      { name: "Average" },
                      { name: "Source 1 - Receiver 1" },
                      { name: "Source 1 - Receiver 2" },
                      { name: "Source 2 - Receiver 1" },
                      { name: "Source 2 - Receiver 2" },
                    ],
                  },
                ],
                controlsPosition: "bottom",
                extraContent: [[], [], [], [], []],
                components: [a, b, c, d, e],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
